module.exports = __webpack_public_path__ + "static/media/jubilaeumsball.27b5cab3.png";